<div class="box">
  <nz-input-group [nzPrefix]="prefixIconSearch" [nzSuffix]="suffixIconClose">
    <input type="search" class="searchBox" [(ngModel)]="searchFilter" (ngModelChange)="searchInput.next($event)"
      nz-input [placeholder]="placeholderText"/>
  </nz-input-group>
  <ng-template #prefixIconSearch>
    <img [src]="images.SEARCH_ICON" class="search-icon" alt="{{ 'MENU_CMM.SEARCH' | fallbackTranslate }}"
      (click)="searchInput.next(searchFilter)">
  </ng-template>
  <ng-template #suffixIconClose>
    <img [src]="images.CLOSE" class="close-icon" (click)="searchInput.next(''); closeSearch()"
      *ngIf="searchFilter" alt="{{ 'MENU_CMM.CLOSE' | fallbackTranslate }}">
  </ng-template>
</div>